<template>
  <div>
    <form @submit.prevent="$emit('form-submit', form, day)">
      <div class="field">
        <label for="walking-time-goal">
          <span>How many minutes did you hope to walk today?</span>
          <input
            type="number"
            name="walking-time-goal"
            min="0"
            v-model="form.walkingTimeGoal"
            required
          />
        </label>
      </div>

      <div class="field">
        <label for="walking-time">
          <span>How many minutes did you walk today?</span>
          <input
            type="number"
            name="walking-time"
            min="0"
            v-model="form.walkingTime"
            required
          />
        </label>
      </div>

      <div class="field">
        <button class="button button--standard" type="submit">
          <span v-if="day.edit">Update</span>
          <span v-else>Set your walking time!</span>
        </button>
        <button
          class="button button--danger"
          v-if="day.edit"
          @click.prevent="$emit('cancel-edit', day)"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "Form",
  props: ["existingEntry", "day"],

  data() {
    return {
      form: {
        // Add form field data here. This data will be submitted to Firestore and
        // should match the v-model values from your form fields.
        walkingTimeGoal: this.existingEntry
          ? this.existingEntry.data.walkingTimeGoal
          : "",

        walkingTime: this.existingEntry
          ? this.existingEntry.data.walkingTime
          : "",
      },
    };
  },
};
</script>

<style>
button {
  margin-right: 1rem;
}
</style>
